import moment from 'moment';
import { ISearchLimitOffset } from './ISearchLimitOffset';

export interface IFilterSocieteBO extends ISearchLimitOffset {
    IdSociete?: number | null;
    RaisonSociale?: string;
    DateDebut?: Date;
    DateFin?: Date;
    IdsTypeCompteSociete?: number[];
    Siren?: string;
    SortField?: string;
    IsDescending?:boolean;
  }

  export interface IFilterSocieteBODTO extends ISearchLimitOffset {
    IdSociete?: number | null;
    RaisonSociale?: string;
    DateDebut?: string;
    DateFin?: string;
    IdsTypeCompteSociete?: number[];
    Siren?: string;
    SortField?: string;
    IsDescending?:boolean;
}


  export const getDefaultFilterSociete = (): IFilterSocieteBO => ({
    IdSociete: null,
    RaisonSociale: undefined,
    DateDebut: undefined,
    DateFin: undefined,
    IdsTypeCompteSociete: undefined,
    Siren: undefined,
    Offset: 0,
    Limit: 10,
    SortField: "Libelle",
    IsDescending: true,
  });
  

  export const dtoToFilter = (dto: IFilterSocieteBODTO): IFilterSocieteBO => {
  
    return {
      IdSociete: dto.IdSociete,
      RaisonSociale: dto.RaisonSociale,
      DateDebut: dto.DateDebut ? new Date(dto.DateDebut) : undefined,
      DateFin: dto.DateFin ? new Date(dto.DateFin) : undefined,
      IdsTypeCompteSociete: dto.IdsTypeCompteSociete,
      Siren: dto.Siren,
      Limit: dto.Limit !== undefined ? dto.Limit : 10,
      Offset: dto.Offset !== undefined ? dto.Offset : 0,
    };
  };
 


  export const filterToQuery = (filter: IFilterSocieteBO): IFilterSocieteBODTO => {
    const dto: IFilterSocieteBODTO = {
      IdSociete: undefined,
      RaisonSociale: "",
      DateDebut: "",
      DateFin: "",
      IdsTypeCompteSociete: undefined,
      Siren:"",
      SortField: "",
      IsDescending: false
  };
 
    if (filter?.IdSociete !== undefined ) {
      dto.IdSociete = filter.IdSociete;
    } 

  
    if (filter?.RaisonSociale !== undefined ) {
      dto.RaisonSociale = filter.RaisonSociale;
    } 

    if (filter.DateDebut) {
      if (filter.DateDebut instanceof Date) {
          // Supprimer l'utilisation de toISOString car elle retourne la date avec l'heure en format UTC.
          dto.DateDebut = moment(new Date(filter.DateDebut?.getFullYear(),filter.DateDebut?.getMonth(),filter.DateDebut?.getDate(),0,0,0)).format("YYYY-MM-DDTHH:mm:ss.sssZ");
      } else {
          dto.DateDebut = filter.DateDebut;
      }
      
  }
  if (filter.DateFin) {
      if (filter.DateFin instanceof Date) {
          //Supprimer l'utilisation de toISOString car elle retourne la date avec l'heure en format UTC.
          dto.DateFin = moment(new Date(filter.DateFin?.getFullYear(),filter.DateFin?.getMonth(),filter.DateFin?.getDate(),0,0,0)).format("YYYY-MM-DDTHH:mm:ss.sssZ");
      } else {
          dto.DateFin = filter.DateFin;
      }
  }

  if (filter?.IdsTypeCompteSociete !== undefined ) {
    dto.IdsTypeCompteSociete = filter.IdsTypeCompteSociete;
  } 

  if (filter?.Siren !== undefined ) {
    dto.Siren = filter.Siren;
  } 


    if (filter?.Limit) {
      dto.Limit = filter.Limit;
    } else {
      dto.Limit = 10;
    }
    if (filter?.Offset) {
      dto.Offset = filter.Offset;
    } else {
      dto.Offset = 0;
    }
  
    if (filter?.IsDescending) {
      dto.IsDescending = filter.IsDescending;
    } else {
      dto.IsDescending = false;
    }
  
    if (filter?.SortField) {
      dto.SortField = filter.SortField;
    } else {
      dto.SortField = "";
    }

    localStorage.setItem("IFilterSocietesBO", JSON.stringify(dto));
  
    return dto;
  };
  
